<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { useBrand } from '~/composables/useBrand';
import { useSchemaOrg, defineWebPage } from '@unhead/schema-org/vue';
import VContainer from '~/components/VContainer.vue';
import VProductListing from '~/components/VProductListing.vue';

const route = useRoute();
const localePath = useLocalePath();

const { data: brand , fetchBrand } = useBrand();
await fetchBrand();

useSeoMeta({
    title: brand.value?.meta_title,
    description: brand.value?.meta_description,
    ogTitle: brand.value?.meta_title,
    ogDescription: brand.value?.meta_description,
});

useSchemaOrg([
    defineWebPage({
        title: brand.value?.meta_title,
        description: brand.value?.meta_description,
    }),
]);
</script>

<template>
  <VContainer  class="relative">
    <Breadcrumbs
      class="mt-4"
      :breadcrumbs="[
        { title: 'Home', url: localePath('/') },
        { title: 'Brands', url: localePath('/brands') },
        { title: brand?.name ?? '', url: localePath(route.fullPath) }
      ]"
    />

    <VProductListing 
      :brandId="brand?.link_rewrite"
      :title="brand?.name"
      :short_description="brand?.short_description"
      :description="brand?.description"
      :cover_image="brand?.cover_image"
    />
  </VContainer>
</template>
